import Icon from '../components/Icon.vue'

Icon.register({
  upload: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M296 384h-80c-13.3 0-24-10.7-24-24v-168h-87.7c-17.8 0-26.7-21.5-14.1-34.1l152.1-152.2c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1h-87.7v168c0 13.3-10.7 24-24 24zM512 376v112c0 13.3-10.7 24-24 24h-464c-13.3 0-24-10.7-24-24v-112c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zM388 464c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zM452 464c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/upload.js
// module id = 2053
// module chunks = 0